import { useTranslation } from 'react-i18next'

import agencyPng from '@/assets/images/agency.png'
import { useAuthContext } from '@/contexts/auth-context'
import { env } from '@/env'

import { Button } from '../ui/button'

export function AgencyChainMenuOption() {
  const { t } = useTranslation('sidebar')
  const {
    isAgencyAdmin,
    isAgencyOfficeAdmin,
    isChainAgencyAdmin,
    isSystemAdmin,
  } = useAuthContext()

  const redirectExternal = (path: string) => {
    const urlsByEnvironment = {
      internal: 'https://agency-internal.b2breservas.com.br',
      dev: 'https://agency-homolog.b2breservas.com.br',
      homolog: 'https://agency-homolog.b2breservas.com.br',
      production: 'https://company.b2breservas.com.br',
    }

    const baseUrl =
      urlsByEnvironment[env.VITE_ENV as keyof typeof urlsByEnvironment] ||
      urlsByEnvironment.production

    if (env.VITE_ENV === 'internal') {
      window.location.href = `https://agency-internal.b2breservas.com.br${path}`
      return
    }

    window.location.href = `${baseUrl}${path}`
  }

  const requiredRoles = [
    isAgencyAdmin,
    isAgencyOfficeAdmin,
    isChainAgencyAdmin,
    isSystemAdmin,
  ]

  if (requiredRoles.some(Boolean) === false) {
    return null
  }

  return (
    <Button
      variant="outline"
      type="button"
      className="bg-transparent justify-start px-2 border border-[#CCC]/50 text-white font-medium w-full hover:bg-white/10"
      onClick={() => redirectExternal('/')}
    >
      <img src={agencyPng} alt="" className="size-6 mr-2" />
      {t('--actions-back-to-agency')}
    </Button>
  )
}
